import script from "./high.vue?vue&type=script&setup=true&lang=js"
export * from "./high.vue?vue&type=script&setup=true&lang=js"

import "./high.vue?vue&type=style&index=0&id=28e4c511&lang=less"

const __exports__ = script;

export default __exports__